import { notification as antdNotification } from 'antd';
import { ReactNode } from 'react';

export const notification = {
  error(message: string, description?: string | ReactNode, duration: number = 5) {
    return antdNotification.error({
      message: message || '',
      description: description || '',
      duration,
      placement: 'topRight',
    });
  },

  success(message: string, description?: string | ReactNode, duration: number = 5) {
    return antdNotification.success({
      message: message || '',
      description: description || '',
      duration,
      placement: 'topRight',
    });
  },

  info(message: string, description?: string | ReactNode, duration: number = 5) {
    return antdNotification.info({
      message: message || '',
      description: description || '',
      duration,
      placement: 'topRight',
    });
  },

  warning(message: string, description?: string | ReactNode, duration: number = 5) {
    return antdNotification.warning({
      message: message || '',
      description: description || '',
      duration,
      placement: 'topRight',
    });
  },

  destroy() {
    return antdNotification.destroy();
  },
};

export default notification;
